import {DecadenceSymbol} from "../symbols/DecadenceSymbol";
import {gsap, Power2} from "gsap"
import {Decadence} from "../Decadence";
import {DecadenceStatics} from "../config/DecadenceStatics";
import {DecadenceGameAssets} from "../DecadenceGameAssets";

export class BasedMiniReel extends PIXI.Container {

    public reelID:number;

    public symbols:DecadenceSymbol[] = [];
    public symbolsContainer:PIXI.Container;
    public stepSize = DecadenceStatics.SYMBOL_HEIGHT;
    public stepDuration = DecadenceStatics.spinStepDuration;

    public reelSet:string[];

    public visibleSymbols:number;

    public isSpinning:boolean = false;
    public spinTimeline:gsap.core.Timeline;

    public bounceFactor:number = 0.05;
    public bounceDuration:number = 0.13;

    public stopEase:string = "none";
    public stopSymbol:DecadenceSymbol;

    public spinningMask:PIXI.DisplayObject;

    private reelMode2Mask:PIXI.Sprite;
    private reelMode4Mask:PIXI.Sprite;

    public stepData = {
        y: 0
    };

    constructor(reelID:number, visibleSymbols:number) {
        super();

        this.name = "DecadenceReel";
        this.visibleSymbols = visibleSymbols;
        this.reelID = reelID;

        this.symbolsContainer = new PIXI.Container();
        this.symbolsContainer.name = "Symbols";
        this.addChild(this.symbolsContainer);

        this.setMask(1);
        //this.mask = this.spinningMask;
        //this.addChild(this.spinningMask);
    }

    public setMask(reelMode:number) {
        if(reelMode == 1) {
            const width = DecadenceStatics.SYMBOL_WIDTH;
            const height = DecadenceStatics.SYMBOL_HEIGHT;
            this.removeChild(this.spinningMask);
            const mask = new PIXI.Graphics;
            mask.beginFill();
            mask.drawRect(-width/2, -height/2, width, height+50);
            this.spinningMask = mask;
        } else {
            const sp = DecadenceGameAssets.createSprite(`screen_${reelMode}_alpha_${this.reelID+1}`);
            sp.anchor.set(0.5, 0.5);
            const centerY = 529; // 515
            const centerX = 354;
            const yOffset = centerY - this.position.y;
            const xOffset = centerX - this.position.x;
            sp.position.set(
                xOffset,
                yOffset
            );

            // Hackjob deluxe gaming
            if(reelMode == 2 && (this.reelID == 1)) {
                sp.position.y += 5;
            } else if(reelMode == 4 && (this.reelID == 1 || this.reelID == 3)) {
                sp.position.y += 5;
            }

            //this.addChild(sp);
            this.spinningMask = sp;
        }

        this.updateSymbolsPosition();
    }

    public insertSymbols(symbols:DecadenceSymbol[]):void {
        this.symbolsContainer.removeChildren(0, this.symbolsContainer.children.length);
        this.symbols = symbols;
        this.symbolsContainer.addChild(...this.symbols);
        this.updateSymbolsPosition();
    }

    public extractSymbols():DecadenceSymbol[] {
        this.symbolsContainer.removeChildren(0, this.symbolsContainer.children.length);
        const oldSymbols = this.symbols;
        this.symbols = [];
        return oldSymbols;
    }

    public start():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.addChild(this.spinningMask);
            this.mask = <any>this.spinningMask;
        })
        const tween = this.step("back.in(3)");
        tween.totalDuration(this.stepDuration * 8);
        tl.add(tween);
        tl.add(this.symbols[0].crossFadeToSpinning(this.stepDuration * 8), "<")
        tl.add(() => {
            this.isSpinning = true;
            // Show overflow
            this.symbols.forEach(sym => {
                if(sym != this.stopSymbol) {
                    sym.visible = true;
                }
            })
            this.symbols.forEach((sym) => sym.setSpinning());
            this.playSpin();
        });
        return tl;
    }

    public stop(stopSymbol:string, ease:string="none", bounceFactor:number = 0.2): gsap.core.Timeline {
        this.stopSymbol = new DecadenceSymbol(stopSymbol, this.reelID, -1);

        const hackjob = gsap.timeline({paused:true}).add(this.playStop());
        const totalStopTime = 0.1 + this.bounceDuration;
        return gsap.timeline()
            .add(() => {
                // Stop spin timeline
                this.bounceFactor = bounceFactor;
                this.stopEase = ease;
                this.spinTimeline.repeat(0);
                this.spinTimeline.eventCallback("onComplete", () => {
                    hackjob.play(0);
                })
            })
            .add(() => {
                //this.mask = null;
                //this.removeChild(this.spinningMask);
                const paddingSymbols = this.symbols.slice(1, this.symbols.length);
                this.spinTimeline.kill();
                hackjob.progress(1);
            }, `>${totalStopTime}`)
    }

    private playSpin() {
        this.spinTimeline = gsap.timeline();
        this.spinTimeline.add(this.step());
        this.spinTimeline.repeat(-1);
    }

    private playStop() {
        const stopTL = gsap.timeline();

        const totalSteps = this.visibleSymbols;
        const stopDuration = (totalSteps + 1) * this.stepDuration;

        // Add stop symbols to reel
        stopTL.add(() => {
            this.symbols.unshift(this.stopSymbol);
            this.symbolsContainer.addChild(this.stopSymbol);
            this.updateSymbolsPosition();
            this.symbols.forEach((sym) => sym.crossFadeFromSpinning(0.1));
        });
        // Spin in stop symbols
        stopTL.add(gsap.to(this.stepData, {
            y: this.stepSize * totalSteps,
            duration: stopDuration,
            ease: this.stopEase,
            onUpdate: () => {
                this.updateSymbolsPosition();
            },
        }))
        stopTL.add(() => {
            this.symbols.forEach((sym) => {
                sym.reelPosition += 1;
            });
            this.updateSymbolsPosition();
            this.stepData.y = 0;
        })


        // Add bounce
        stopTL.add(gsap.to(this.stepData, {
            y: this.stepSize * this.bounceFactor,
            duration: this.bounceDuration/2,
            ease: "power2.out",
            onUpdate: () => {
                this.updateSymbolsPosition();
            },
        }))
        stopTL.add(gsap.to(this.stepData, {
            y: 0,
            duration: this.bounceDuration/2,
            ease: "power2.out",
            onUpdate: () => {
                this.updateSymbolsPosition();
            }
        }))

        stopTL.add(() => {
            this.isSpinning = false;
            // Hide overflow
            this.symbols.forEach(sym => {
                if(sym != this.stopSymbol) {
                    sym.visible = false;
                }
            })
            this.mask = null;
            this.removeChild(this.spinningMask);
        })

        return stopTL;
    }

    // Moves all symbols one step
    private step(ease:string = "none"):gsap.core.Tween {
        return gsap.to(this.stepData, {
            y: this.stepSize,
            ease,
            duration: this.stepDuration,
            onStart: () => {
                this.addRandomSymbol(-1);
                this.symbols[0].setSpinning();
            },
            onUpdate: () => {
                this.updateSymbolsPosition();
            },
            onComplete: () => {
                this.stepData.y = 0;
                this.symbols.forEach(sym => sym.reelPosition++);

                while (this.symbols[this.symbols.length - 1].reelPosition > 0) {
                    this.symbolsContainer.removeChild(this.symbols[this.symbols.length - 1]);
                    this.symbols.pop();
                }
            }
        });
    }

    public getSymbols():DecadenceSymbol[] {
        return this.isSpinning ? [this.stopSymbol] : this.symbols;
    }

    private updateSymbolsPosition() {
        this.symbols.forEach(sym => {
            const basePos = this.stepSize * sym.reelPosition;
            sym.position.y = basePos + this.stepData.y;
            sym.position.x = 0;
        })
    }

    private getRandomSymbolInReelSet():string {
        const randomIndex = Math.floor(Math.random() * this.reelSet.length);
        return this.reelSet[randomIndex];
    }

    private addRandomSymbol(reelPos:number) {
        const name = this.getRandomSymbolInReelSet()
        const symbol = new DecadenceSymbol(name, this.reelID, reelPos);
        this.symbols.unshift(symbol);
        this.symbolsContainer.addChild(symbol);
    }
}